// utils.js
export const parseContextQueryParam = (search: string, pathname: string) => {
    let customSubEntityId = '';
  
    // Prova a estrarre il parametro `context` dalla query string
    const contextMatch = search.match(/context=([^&]+)/);
    if (contextMatch) {
      try {
        // Decodifica prima il parametro context
        const decodedContext = decodeURIComponent(contextMatch[1]);
        // Esegui il parsing del JSON
        const contextObj = JSON.parse(decodedContext);
  
        // Decodifica il subEntityId se presente
        if (contextObj.subEntityId) {
          //customSubEntityId = atob(contextObj.subEntityId); // Decodifica da base64
          customSubEntityId = contextObj.subEntityId; // Codificato in base64
        }
      } catch (e) {
        console.error("Errore nella decodifica del parametro context:", e);
      }
    }
  
    // Se `subEntityId` non è stato trovato nel parametro context, prova a estrarre dalla pathname
    if (!customSubEntityId) {
      const { archiveId, fileId, isFolder } = parseCustomQueryString(pathname);
  
      // Se uno dei parametri è mancante, ritorna null
      if (!archiveId || !fileId || isFolder === undefined) {
        //console.warn("Parametri mancanti o non validi nella URL:", { archiveId, fileId, isFolder });
        return null;
      }
  
      // Codifica i parametri estratti in base64 per creare il subEntityId
      const pathToEncode = `/teams/doclab/archives/${archiveId}/files/fileid=${fileId}/isfolder=${isFolder}`;
      customSubEntityId = btoa(pathToEncode); // Codifica in base64
    }
  
    return customSubEntityId;
  };
  
  const parseCustomQueryString = (path: string) => {
    try {
      const archiveIdMatch = path.match(/\/archives\/(\d+)/);
      const fileIdMatch = path.match(/fileid=(\d+)/);
      const isFolderMatch = path.match(/isfolder=(true|false)/);
  
      return {
        archiveId: archiveIdMatch ? decodeURIComponent(archiveIdMatch[1]) : undefined,
        fileId: fileIdMatch ? decodeURIComponent(fileIdMatch[1]) : undefined,
        isFolder: isFolderMatch ? isFolderMatch[1] === "true" : undefined,
      };
    } catch (err) {
      console.error("Errore nel parsing della query string:", err);
      return { archiveId: undefined, fileId: undefined, isFolder: undefined };
    }
  };
  